import { createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromAutenticacionModel from './autenticacion.model';

export const selectAutenticacionoState = createFeatureSelector<fromAutenticacionModel.AutenticacionState>(
  fromAutenticacionModel.autenticacionFeatureKey
);


export const selectSession = createSelector(
  selectAutenticacionoState,
  (state: fromAutenticacionModel.AutenticacionState) => state?.ss);

export const selectTemporalSession = createSelector(
  selectAutenticacionoState,
  (state: fromAutenticacionModel.AutenticacionState) => state?.temporal);

  export const selectPerfil = createSelector(
    selectAutenticacionoState,
    (state: fromAutenticacionModel.AutenticacionState) => state?.pr);


